module.exports = __webpack_public_path__ + "img/client11.499821cf.webp";